var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddPlus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-plus 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 2.6665C8.36803 2.6665 8.6665 2.96498 8.6665 3.33317V7.33317H12.6665C13.0347 7.33317 13.3332 7.63165 13.3332 7.99984C13.3332 8.36803 13.0347 8.6665 12.6665 8.6665H8.6665V12.6665C8.6665 13.0347 8.36803 13.3332 7.99984 13.3332C7.63165 13.3332 7.33317 13.0347 7.33317 12.6665V8.6665H3.33317C2.96498 8.6665 2.6665 8.36803 2.6665 7.99984C2.6665 7.63165 2.96498 7.33317 3.33317 7.33317H7.33317V3.33317C7.33317 2.96498 7.63165 2.6665 7.99984 2.6665Z",
    fill: "#45A9EF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddPlus);
export default ForwardRef;